import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const history = useNavigate();

  useEffect(() => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("isLoggedIn");
    history("/login");
  }, []);

  return <></>;
};

export default Logout;
